<template>
  <div class="base-menu fixed top0 left0 w100 z999"
       :class="{expand: isOpen}">

    <nav class="w100 top0 bg-white">
      <router-link class="logo absolute inline-block" to="/">
        <img class="h100"
             alt="logo"
             src="../assets/logo.jpg">
      </router-link>

      <i class="icon hamb-menu-icon absolute"
         @click="isOpen = true">
        <svg width="28px" height="19px" viewBox="0 0 28 19">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M0.5,0 L28,0 L28,3.08 L0.5,3.08 L0.5,0 Z M0.5,10.67 L0.5,7.66333333 L28,7.66333333 L28,10.67 L0.5,10.67 Z M0.5,18.3333333 L0.5,15.2533333 L28,15.2533333 L28,18.3333333 L0.5,18.3333333 Z" id="menu---material" fill="#000000"></path>
          </g>
        </svg>
      </i>

      <i class="icon close-icon absolute"
         @click="isOpen = false">
        <svg width="20px" height="19px" viewBox="0 0 20 19">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M18.8125003,15.9817708 C18.9444454,16.1137159 19.0104169,16.2786448 19.0104169,16.4765625 C19.0104169,16.6744802 18.9444454,16.8394091 18.8125003,16.9713542 L16.9322919,18.8020833 C16.8003468,18.9340284 16.6519108,19 16.4869794,19 C16.2890618,19 16.1241329,18.9340284 15.9921878,18.8020833 L9.51041693,12.3203125 L3.02864609,18.8020833 C2.89670099,18.9340284 2.74826497,19 2.58333359,19 C2.38541594,19 2.22048703,18.9340284 2.08854193,18.8020833 L0.208333594,16.9713542 C0.0763884896,16.8394091 0.0104169271,16.6744802 0.0104169271,16.4765625 C0.0104169271,16.2786448 0.0763884896,16.1137159 0.208333594,15.9817708 L6.73958359,9.5 L0.208333594,3.06770833 C-0.121529167,2.73784557 -0.121529167,2.40798776 0.208333594,2.078125 L2.03906276,0.197916667 C2.23698042,0.0659715625 2.40190932,0 2.53385443,0 C2.73177208,0 2.89670099,0.0659715625 3.02864609,0.197916667 L9.51041693,6.63020833 L15.9921878,0.197916667 C16.1901054,0.0659715625 16.3550343,0 16.4869794,0 C16.6848971,0 16.849826,0.0659715625 16.9817711,0.197916667 L18.8125003,2.078125 C19.142363,2.40798776 19.142363,2.72135268 18.8125003,3.01822917 L12.2812503,9.45052083 L18.8125003,15.9817708 Z" id="ion-close---Ionicons" fill="#000000"></path>
          </g>
        </svg>
      </i>

      <a class="fb"
         href="https://www.facebook.com/textebune/"
         target="_blank">
        <img src="../assets/fb.png" alt="fb">
      </a>
    </nav>

    <ul class="text-center w100 flex" :class="{expand: isOpen}">
      <li class="uppercase"
          @click="isOpen = false"
          v-for="(item,key) in menu"
          :key="key">
        <router-link :to="'/' + key">
          {{ item }}
        </router-link>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  name: 'BaseMenu',
  data () {
    return {
      isOpen: false,
      menu: {
        about: 'about',
        events: 'events',
        video: 'video',
        press: 'press',
        news: 'news',
        contact: 'contact'
      }
    }
  }
}
</script>

<style lang="less">
  @import "../styles/var";
  .base-menu {
    .logo {
      height: 76px;
      margin-top: 6px;
      left: 16px;
    }

    @media only screen and (min-width: 320px) {
      height: 70px;
      transition: height 500ms ease-in-out;
      .fb {
        display: none;
      }
      nav {
        transition: height 0.4s ease-in-out;
        height: 70px;
        border-bottom: 1px solid lightgrey;
        align-items: center;
        padding-left: 2px;
        position: absolute;
      }
      .icon {
        top: 24px;
      }
      .hamb-menu-icon {
        transition: right 0.2s ease-in-out;
        right: 24px;
      }
      .close-icon {
        transition: right 0.2s ease-in-out;
        right: -30px;
      }
      ul {
        transition: height 500ms ease-in-out;
        width: 100%;
        height: 0;
        background-color: white;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        overflow: hidden;
      }
      li {
        line-height: 1.8;
        font-size: 2rem;
      }
    }

    @media only screen and (min-width: 1024px) {
      display: block;
      .fb {
        display: block;
        padding-right: 32px;
        img {
          width: 32px;
        }
      }
      .icon {
        display: none;
      }
      .logo {
        position: relative;
        margin-top: 18px;
      }
      nav {
        display: flex;
        justify-content: space-between;
        position: relative;
        z-index: -1;
      }
      ul {
        width: 80%;
        margin: -70px auto 0 auto;
        max-width: 600px;
        background: transparent;
        height: 70px;
        justify-content: space-between;
        flex-direction: row;
        position: relative;
        z-index: 10;
      }
    }
  }

  .expand {
    height: 100%;
    .hamb-menu-icon {
      right: -30px;
    }
    .close-icon {
      right: 24px;
    }
    ul {
      height: 99%;
    }
  }

  .router-link-exact-active {
    font-weight: 700;
    border-bottom: 1px solid @dark-gray;
  }
</style>
